import type { EventCard } from '@/api/types';
import { ConditionItem, ConditionList } from '@/components/kit/Controls';
import { Modal } from '@/components/kit/Modal';
import { checks as checksPlural } from '@/lib/format';

/**
 * Окно публикации.
 *
 * Показывает все двенадцать проверок и их состояние — те же самые,
 * что проверит сервер. Кнопка неактивна, пока не пройдены все:
 * отказ после нажатия объясняет меньше, чем список перед ним.
 */
export function PublishModal({
  event,
  onClose,
  onPublish,
  pending,
}: {
  event: EventCard;
  onClose: () => void;
  onPublish: () => void;
  pending: boolean;
}) {
  const passed = event.readiness.filter((c) => c.ok).length;
  const total = event.readiness.length;
  const ready = passed === total;

  return (
    <Modal
      title={`Опубликовать «${event.city}»?`}
      onClose={onClose}
      confirm={{
        label: pending ? 'Публикуем…' : 'Опубликовать',
        onClick: onPublish,
        disabled: !ready || pending,
      }}
    >
      <p className="txt">
        После публикации мероприятие появится у отдела продаж, откроется приём заявок
        и заработают дедлайны.{' '}
        {ready ? (
          <b>Всё готово.</b>
        ) : (
          <>
            Пока не пройдено <b>{checksPlural(total - passed)}</b> из {total}.
          </>
        )}
      </p>

      <ConditionList>
        {event.readiness.map((c) => (
          <ConditionItem key={c.key} done={c.ok} name={c.name} hint={c.hint} />
        ))}
      </ConditionList>
    </Modal>
  );
}
